var He = Object.defineProperty;
var qe = (t, e, r) => e in t ? He(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var ae = (t, e, r) => (qe(t, typeof e != "symbol" ? e + "" : e, r), r);
import { W as Je, D as Ke } from "./index-2c02a314.js";
import { A as $e } from "./index-ed16cdbf.js";
import { I as fe, A as Me } from "./index-9e581434.js";
import { s as et, r as tt } from "./lastConnected-b964dc30.js";
import "starknet";
import "./publicRcpNodes-3828330a.js";
var rt = Object.defineProperty, nt = (t, e, r) => e in t ? rt(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, it = (t, e, r) => (nt(t, typeof e != "symbol" ? e + "" : e, r), r), pe = (t, e, r) => {
  if (!e.has(t))
    throw TypeError("Cannot " + r);
}, z = (t, e, r) => (pe(t, e, "read from private field"), r ? r.call(t) : e.get(t)), V = (t, e, r) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, r);
}, ie = (t, e, r, n) => (pe(t, e, "write to private field"), n ? n.call(t, r) : e.set(t, r), r), $ = (t, e, r) => (pe(t, e, "access private method"), r);
const ot = [
  {
    id: "argentX",
    name: "Argent X",
    icon: "data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjQwIiBoZWlnaHQ9IjM2IiB2aWV3Qm94PSIwIDAgNDAgMzYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yNC43NTgyIC0zLjk3MzY0ZS0wN0gxNC42MjM4QzE0LjI4NTEgLTMuOTczNjRlLTA3IDE0LjAxMzggMC4yODExNzggMTQuMDA2NCAwLjYzMDY4M0MxMy44MDE3IDEwLjQ1NDkgOC44MjIzNCAxOS43NzkyIDAuMjUxODkzIDI2LjM4MzdDLTAuMDIwMjA0NiAyNi41OTMzIC0wLjA4MjE5NDYgMjYuOTg3MiAwLjExNjczNCAyNy4yNzA5TDYuMDQ2MjMgMzUuNzM0QzYuMjQ3OTYgMzYuMDIyIDYuNjQwOTkgMzYuMDg3IDYuOTE3NjYgMzUuODc1NEMxMi4yNzY1IDMxLjc3MjggMTYuNTg2OSAyNi44MjM2IDE5LjY5MSAyMS4zMzhDMjIuNzk1MSAyNi44MjM2IDI3LjEwNTcgMzEuNzcyOCAzMi40NjQ2IDM1Ljg3NTRDMzIuNzQxIDM2LjA4NyAzMy4xMzQxIDM2LjAyMiAzMy4zMzYxIDM1LjczNEwzOS4yNjU2IDI3LjI3MDlDMzkuNDY0MiAyNi45ODcyIDM5LjQwMjIgMjYuNTkzMyAzOS4xMzA0IDI2LjM4MzdDMzAuNTU5NyAxOS43NzkyIDI1LjU4MDQgMTAuNDU0OSAyNS4zNzU5IDAuNjMwNjgzQzI1LjM2ODUgMC4yODExNzggMjUuMDk2OSAtMy45NzM2NGUtMDcgMjQuNzU4MiAtMy45NzM2NGUtMDdaIiBmaWxsPSIjRkY4NzVCIi8+Cjwvc3ZnPgo=",
    downloads: {
      chrome: "https://chrome.google.com/webstore/detail/argent-x-starknet-wallet/dlcobpjiigpikoobohmabehhmhfoodbb",
      firefox: "https://addons.mozilla.org/en-US/firefox/addon/argent-x"
    }
  },
  {
    id: "braavos",
    name: "Braavos",
    icon: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aAogICAgICAgIGQ9Ik02Mi43MDUgMTMuOTExNkM2Mi44MzU5IDE0LjEzMzMgNjIuNjYyMSAxNC40MDcgNjIuNDAzOSAxNC40MDdDNTcuMTgwNyAxNC40MDcgNTIuOTM0OCAxOC41NDI3IDUyLjgzNTEgMjMuNjgxN0M1MS4wNDY1IDIzLjM0NzcgNDkuMTkzMyAyMy4zMjI2IDQ3LjM2MjYgMjMuNjMxMUM0Ny4yMzYxIDE4LjUxNTYgNDMuMDAwOSAxNC40MDcgMzcuNzk0OCAxNC40MDdDMzcuNTM2NSAxNC40MDcgMzcuMzYyNSAxNC4xMzMxIDM3LjQ5MzUgMTMuOTExMkM0MC4wMjE3IDkuNjI4MDkgNDQuNzIwNCA2Ljc1IDUwLjA5OTEgNi43NUM1NS40NzgxIDYuNzUgNjAuMTc2OSA5LjYyODI2IDYyLjcwNSAxMy45MTE2WiIKICAgICAgICBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMzcyXzQwMjU5KSIgLz4KICAgIDxwYXRoCiAgICAgICAgZD0iTTc4Ljc2MDYgNDUuODcxOEM4MC4yNzI1IDQ2LjMyOTcgODEuNzAyNSA0NS4wMDU1IDgxLjE3MTQgNDMuNTIyMkM3Ni40MTM3IDMwLjIzMzQgNjEuMzkxMSAyNC44MDM5IDUwLjAyNzcgMjQuODAzOUMzOC42NDQyIDI0LjgwMzkgMjMuMjg2OCAzMC40MDcgMTguODc1NCA0My41OTEyQzE4LjM4MjQgNDUuMDY0NSAxOS44MDgzIDQ2LjM0NDYgMjEuMjk3OCA0NS44ODgxTDQ4Ljg3MiAzNy40MzgxQzQ5LjUzMzEgMzcuMjM1NSA1MC4yMzk5IDM3LjIzNDQgNTAuOTAxNyAzNy40MzQ4TDc4Ljc2MDYgNDUuODcxOFoiCiAgICAgICAgZmlsbD0idXJsKCNwYWludDFfbGluZWFyXzM3Ml80MDI1OSkiIC8+CiAgICA8cGF0aAogICAgICAgIGQ9Ik0xOC44MTMyIDQ4LjE3MDdMNDguODkzNSAzOS4wNDcyQzQ5LjU1MDYgMzguODQ3OCA1MC4yNTI0IDM4Ljg0NzMgNTAuOTA5OCAzOS4wNDU2TDgxLjE3ODEgNDguMTc1MkM4My42OTEyIDQ4LjkzMzIgODUuNDExIDUxLjI0ODMgODUuNDExIDUzLjg3MzVWODEuMjIzM0M4NS4yOTQ0IDg3Ljg5OTEgNzkuMjk3NyA5My4yNSA3Mi42MjQ1IDkzLjI1SDYxLjU0MDZDNjAuNDQ0OSA5My4yNSA1OS41NTc3IDkyLjM2MzcgNTkuNTU3NyA5MS4yNjhWODEuNjc4OUM1OS41NTc3IDc3LjkwMzEgNjEuNzkyMSA3NC40ODU1IDY1LjI0OTggNzIuOTcyOUM2OS44ODQ5IDcwLjk0NTQgNzUuMzY4MSA2OC4yMDI4IDc2LjM5OTQgNjIuNjk5MkM3Ni43MzIzIDYwLjkyMjkgNzUuNTc0MSA1OS4yMDk0IDczLjgwMjQgNTguODU3M0M2OS4zMjI2IDU3Ljk2NjcgNjQuMzU2MiA1OC4zMTA3IDYwLjE1NjQgNjAuMTg5M0M1NS4zODg3IDYyLjMyMTkgNTQuMTQxNSA2NS44Njk0IDUzLjY3OTcgNzAuNjMzN0w1My4xMjAxIDc1Ljc2NjJDNTIuOTQ5MSA3Ny4zMzQ5IDUxLjQ3ODUgNzguNTM2NiA0OS45MDE0IDc4LjUzNjZDNDguMjY5OSA3OC41MzY2IDQ3LjA0NjUgNzcuMjk0IDQ2Ljg2OTYgNzUuNjcxMkw0Ni4zMjA0IDcwLjYzMzdDNDUuOTI0OSA2Ni41NTI5IDQ1LjIwNzkgNjIuNTg4NyA0MC45ODk1IDYwLjcwMThDMzYuMTc3NiA1OC41NDk0IDMxLjM0MTkgNTcuODM0NyAyNi4xOTc2IDU4Ljg1NzNDMjQuNDI2IDU5LjIwOTQgMjMuMjY3OCA2MC45MjI5IDIzLjYwMDcgNjIuNjk5MkMyNC42NDEgNjguMjUwNyAzMC4wODEyIDcwLjkzMDUgMzQuNzUwMyA3Mi45NzI5QzM4LjIwOCA3NC40ODU1IDQwLjQ0MjQgNzcuOTAzMSA0MC40NDI0IDgxLjY3ODlWOTEuMjY2M0M0MC40NDI0IDkyLjM2MiAzOS41NTU1IDkzLjI1IDM4LjQ1OTkgOTMuMjVIMjcuMzc1NkMyMC43MDI0IDkzLjI1IDE0LjcwNTcgODcuODk5MSAxNC41ODkxIDgxLjIyMzNWNTMuODY2M0MxNC41ODkxIDUxLjI0NDYgMTYuMzA0NSA0OC45MzE2IDE4LjgxMzIgNDguMTcwN1oiCiAgICAgICAgZmlsbD0idXJsKCNwYWludDJfbGluZWFyXzM3Ml80MDI1OSkiIC8+CiAgICA8ZGVmcz4KICAgICAgICA8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMzcyXzQwMjU5IiB4MT0iNDkuMzA1NyIgeTE9IjIuMDc5IiB4Mj0iODAuMzYyNyIgeTI9IjkzLjY1OTciCiAgICAgICAgICAgIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0Y1RDQ1RSIgLz4KICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRkY5NjAwIiAvPgogICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDFfbGluZWFyXzM3Ml80MDI1OSIgeDE9IjQ5LjMwNTciIHkxPSIyLjA3OSIgeDI9IjgwLjM2MjciIHkyPSI5My42NTk3IgogICAgICAgICAgICBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNGNUQ0NUUiIC8+CiAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0ZGOTYwMCIgLz4KICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgICAgIDxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQyX2xpbmVhcl8zNzJfNDAyNTkiIHgxPSI0OS4zMDU3IiB5MT0iMi4wNzkiIHgyPSI4MC4zNjI3IiB5Mj0iOTMuNjU5NyIKICAgICAgICAgICAgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjRjVENDVFIiAvPgogICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGRjk2MDAiIC8+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KPC9zdmc+",
    downloads: {
      chrome: "https://chrome.google.com/webstore/detail/braavos-wallet/jnlgamecbpmbajjfhmmmlhejkemejdma",
      firefox: "https://addons.mozilla.org/en-US/firefox/addon/braavos-wallet",
      edge: "https://microsoftedge.microsoft.com/addons/detail/braavos-wallet/hkkpjehhcnhgefhbdcgfkeegglpjchdc"
    }
  }
], st = () => `${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`, ye = (t) => {
  for (let e = t.length - 1; e > 0; e--) {
    const r = Math.floor(Math.random() * (e + 1));
    [t[e], t[r]] = [t[r], t[e]];
  }
  return t;
};
function ce(...t) {
  return (e) => t.reduce((r, n) => r.then(n), Promise.resolve(e));
}
var W, S, H, we, _e, X, te;
class at {
  constructor(e) {
    V(this, we), V(this, X), V(this, W, !1), V(this, S, void 0), V(this, H, void 0), it(this, "value"), ie(this, H, e), $(this, X, te).call(this);
  }
  set(e) {
    return !z(this, W) && !$(this, X, te).call(this) ? !1 : (this.delete(), this.value = e, e && (ie(this, S, `${z(this, H)}-${st()}`), localStorage.setItem(z(this, S), e)), !0);
  }
  get() {
    return $(this, we, _e).call(this), this.value;
  }
  delete() {
    return !z(this, W) && !$(this, X, te).call(this) ? !1 : (this.value = null, z(this, S) && localStorage.removeItem(z(this, S)), !0);
  }
}
W = /* @__PURE__ */ new WeakMap(), S = /* @__PURE__ */ new WeakMap(), H = /* @__PURE__ */ new WeakMap(), we = /* @__PURE__ */ new WeakSet(), _e = function() {
  this.value && this.set(this.value);
}, X = /* @__PURE__ */ new WeakSet(), te = function() {
  try {
    !z(this, W) && typeof window < "u" && (ie(this, S, Object.keys(localStorage).find(
      (t) => t.startsWith(z(this, H))
    )), ie(this, W, !0), z(this, S) && this.set(localStorage.getItem(z(this, S))));
  } catch (t) {
    console.warn(t);
  }
  return z(this, W);
};
function le(t, e) {
  var r, n;
  if ((r = e?.include) != null && r.length) {
    const i = new Set(e.include);
    return t.filter((s) => i.has(s.id));
  }
  if ((n = e?.exclude) != null && n.length) {
    const i = new Set(e.exclude);
    return t.filter((s) => !i.has(s.id));
  }
  return t;
}
const ve = async (t) => {
  const e = await Promise.all(
    t.map((r) => r.isPreauthorized().catch(() => !1))
  );
  return t.filter((r, n) => e[n]);
}, ct = (t) => {
  try {
    return t && [
      "request",
      "isConnected",
      "provider",
      "enable",
      "isPreauthorized",
      "on",
      "off",
      "version",
      "id",
      "name",
      "icon"
    ].every((e) => e in t);
  } catch {
  }
  return !1;
};
function de(t, e) {
  return Object.values(
    Object.getOwnPropertyNames(t).reduce((r, n) => {
      if (n.startsWith("starknet")) {
        const i = t[n];
        e(i) && !r[i.id] && (r[i.id] = i);
      }
      return r;
    }, {})
  );
}
const ue = (t, e) => {
  if (e && Array.isArray(e)) {
    t.sort((n, i) => e.indexOf(n.id) - e.indexOf(i.id));
    const r = t.length - e.length;
    return [
      ...t.slice(r),
      ...ye(t.slice(0, r))
    ];
  } else
    return ye(t);
}, lt = typeof window < "u" ? window : {}, dt = {
  windowObject: lt,
  isWalletObject: ct,
  storageFactoryImplementation: (t) => new at(t)
};
function ut(t = {}) {
  const { storageFactoryImplementation: e, windowObject: r, isWalletObject: n } = {
    ...dt,
    ...t
  }, i = e("gsw-last");
  return {
    getAvailableWallets: async (s = {}) => {
      const a = de(
        r,
        n
      );
      return ce(
        (d) => le(d, s),
        (d) => ue(d, s.sort)
      )(a);
    },
    getPreAuthorizedWallets: async (s = {}) => {
      const a = de(
        r,
        n
      );
      return ce(
        (d) => ve(d),
        (d) => le(d, s),
        (d) => ue(d, s.sort)
      )(a);
    },
    getDiscoveryWallets: async (s = {}) => ce(
      (a) => le(a, s),
      (a) => ue(a, s.sort)
    )(ot),
    getLastConnectedWallet: async () => {
      const s = i.get(), a = de(r, n).find(
        (u) => u.id === s
      ), [d] = await ve(
        a ? [a] : []
      );
      return d || (i.delete(), null);
    },
    enable: async (s, a) => {
      if (await s.enable(a ?? { starknetVersion: "v5" }), !s.isConnected)
        throw new Error("Failed to connect to wallet");
      return i.set(s.id), s;
    },
    disconnect: async ({ clearLastWallet: s } = {}) => {
      s && i.delete();
    }
  };
}
const re = ut(), gt = {
  "Amazon Silk": "amazon_silk",
  "Android Browser": "android",
  Bada: "bada",
  BlackBerry: "blackberry",
  Chrome: "chrome",
  Chromium: "chromium",
  Electron: "electron",
  Epiphany: "epiphany",
  Firefox: "firefox",
  Focus: "focus",
  Generic: "generic",
  "Google Search": "google_search",
  Googlebot: "googlebot",
  "Internet Explorer": "ie",
  "K-Meleon": "k_meleon",
  Maxthon: "maxthon",
  "Microsoft Edge": "edge",
  "MZ Browser": "mz",
  "NAVER Whale Browser": "naver",
  Opera: "opera",
  "Opera Coast": "opera_coast",
  PhantomJS: "phantomjs",
  Puffin: "puffin",
  QupZilla: "qupzilla",
  QQ: "qq",
  QQLite: "qqlite",
  Safari: "safari",
  Sailfish: "sailfish",
  "Samsung Internet for Android": "samsung_internet",
  SeaMonkey: "seamonkey",
  Sleipnir: "sleipnir",
  Swing: "swing",
  Tizen: "tizen",
  "UC Browser": "uc",
  Vivaldi: "vivaldi",
  "WebOS Browser": "webos",
  WeChat: "wechat",
  "Yandex Browser": "yandex",
  Roku: "roku"
}, Le = {
  amazon_silk: "Amazon Silk",
  android: "Android Browser",
  bada: "Bada",
  blackberry: "BlackBerry",
  chrome: "Chrome",
  chromium: "Chromium",
  electron: "Electron",
  epiphany: "Epiphany",
  firefox: "Firefox",
  focus: "Focus",
  generic: "Generic",
  googlebot: "Googlebot",
  google_search: "Google Search",
  ie: "Internet Explorer",
  k_meleon: "K-Meleon",
  maxthon: "Maxthon",
  edge: "Microsoft Edge",
  mz: "MZ Browser",
  naver: "NAVER Whale Browser",
  opera: "Opera",
  opera_coast: "Opera Coast",
  phantomjs: "PhantomJS",
  puffin: "Puffin",
  qupzilla: "QupZilla",
  qq: "QQ Browser",
  qqlite: "QQ Browser Lite",
  safari: "Safari",
  sailfish: "Sailfish",
  samsung_internet: "Samsung Internet for Android",
  seamonkey: "SeaMonkey",
  sleipnir: "Sleipnir",
  swing: "Swing",
  tizen: "Tizen",
  uc: "UC Browser",
  vivaldi: "Vivaldi",
  webos: "WebOS Browser",
  wechat: "WeChat",
  yandex: "Yandex Browser"
}, N = {
  tablet: "tablet",
  mobile: "mobile",
  desktop: "desktop",
  tv: "tv"
}, j = {
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MacOS: "macOS",
  iOS: "iOS",
  Android: "Android",
  WebOS: "WebOS",
  BlackBerry: "BlackBerry",
  Bada: "Bada",
  Tizen: "Tizen",
  Linux: "Linux",
  ChromeOS: "Chrome OS",
  PlayStation4: "PlayStation 4",
  Roku: "Roku"
}, L = {
  EdgeHTML: "EdgeHTML",
  Blink: "Blink",
  Trident: "Trident",
  Presto: "Presto",
  Gecko: "Gecko",
  WebKit: "WebKit"
};
class o {
  /**
   * Get first matched item for a string
   * @param {RegExp} regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getFirstMatch(e, r) {
    const n = r.match(e);
    return n && n.length > 0 && n[1] || "";
  }
  /**
   * Get second matched item for a string
   * @param regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getSecondMatch(e, r) {
    const n = r.match(e);
    return n && n.length > 1 && n[2] || "";
  }
  /**
   * Match a regexp and return a constant or undefined
   * @param {RegExp} regexp
   * @param {String} ua
   * @param {*} _const Any const that will be returned if regexp matches the string
   * @return {*}
   */
  static matchAndReturnConst(e, r, n) {
    if (e.test(r))
      return n;
  }
  static getWindowsVersionName(e) {
    switch (e) {
      case "NT":
        return "NT";
      case "XP":
        return "XP";
      case "NT 5.0":
        return "2000";
      case "NT 5.1":
        return "XP";
      case "NT 5.2":
        return "2003";
      case "NT 6.0":
        return "Vista";
      case "NT 6.1":
        return "7";
      case "NT 6.2":
        return "8";
      case "NT 6.3":
        return "8.1";
      case "NT 10.0":
        return "10";
      default:
        return;
    }
  }
  /**
   * Get macOS version name
   *    10.5 - Leopard
   *    10.6 - Snow Leopard
   *    10.7 - Lion
   *    10.8 - Mountain Lion
   *    10.9 - Mavericks
   *    10.10 - Yosemite
   *    10.11 - El Capitan
   *    10.12 - Sierra
   *    10.13 - High Sierra
   *    10.14 - Mojave
   *    10.15 - Catalina
   *
   * @example
   *   getMacOSVersionName("10.14") // 'Mojave'
   *
   * @param  {string} version
   * @return {string} versionName
   */
  static getMacOSVersionName(e) {
    const r = e.split(".").splice(0, 2).map((n) => parseInt(n, 10) || 0);
    if (r.push(0), r[0] === 10)
      switch (r[1]) {
        case 5:
          return "Leopard";
        case 6:
          return "Snow Leopard";
        case 7:
          return "Lion";
        case 8:
          return "Mountain Lion";
        case 9:
          return "Mavericks";
        case 10:
          return "Yosemite";
        case 11:
          return "El Capitan";
        case 12:
          return "Sierra";
        case 13:
          return "High Sierra";
        case 14:
          return "Mojave";
        case 15:
          return "Catalina";
        default:
          return;
      }
  }
  /**
   * Get Android version name
   *    1.5 - Cupcake
   *    1.6 - Donut
   *    2.0 - Eclair
   *    2.1 - Eclair
   *    2.2 - Froyo
   *    2.x - Gingerbread
   *    3.x - Honeycomb
   *    4.0 - Ice Cream Sandwich
   *    4.1 - Jelly Bean
   *    4.4 - KitKat
   *    5.x - Lollipop
   *    6.x - Marshmallow
   *    7.x - Nougat
   *    8.x - Oreo
   *    9.x - Pie
   *
   * @example
   *   getAndroidVersionName("7.0") // 'Nougat'
   *
   * @param  {string} version
   * @return {string} versionName
   */
  static getAndroidVersionName(e) {
    const r = e.split(".").splice(0, 2).map((n) => parseInt(n, 10) || 0);
    if (r.push(0), !(r[0] === 1 && r[1] < 5)) {
      if (r[0] === 1 && r[1] < 6)
        return "Cupcake";
      if (r[0] === 1 && r[1] >= 6)
        return "Donut";
      if (r[0] === 2 && r[1] < 2)
        return "Eclair";
      if (r[0] === 2 && r[1] === 2)
        return "Froyo";
      if (r[0] === 2 && r[1] > 2)
        return "Gingerbread";
      if (r[0] === 3)
        return "Honeycomb";
      if (r[0] === 4 && r[1] < 1)
        return "Ice Cream Sandwich";
      if (r[0] === 4 && r[1] < 4)
        return "Jelly Bean";
      if (r[0] === 4 && r[1] >= 4)
        return "KitKat";
      if (r[0] === 5)
        return "Lollipop";
      if (r[0] === 6)
        return "Marshmallow";
      if (r[0] === 7)
        return "Nougat";
      if (r[0] === 8)
        return "Oreo";
      if (r[0] === 9)
        return "Pie";
    }
  }
  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  static getVersionPrecision(e) {
    return e.split(".").length;
  }
  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions('1.10.2.1',  '1.8.2.1.90')    // 1
   *   compareVersions('1.010.2.1', '1.09.2.1.90');  // 1
   *   compareVersions('1.10.2.1',  '1.10.2.1');     // 0
   *   compareVersions('1.10.2.1',  '1.0800.2');     // -1
   *   compareVersions('1.10.2.1',  '1.10',  true);  // 0
   *
   * @param {String} versionA versions versions to compare
   * @param {String} versionB versions versions to compare
   * @param {boolean} [isLoose] enable loose comparison
   * @return {Number} comparison result: -1 when versionA is lower,
   * 1 when versionA is bigger, 0 when both equal
   */
  /* eslint consistent-return: 1 */
  static compareVersions(e, r, n = !1) {
    const i = o.getVersionPrecision(e), s = o.getVersionPrecision(r);
    let a = Math.max(i, s), d = 0;
    const u = o.map([e, r], (l) => {
      const g = a - o.getVersionPrecision(l), w = l + new Array(g + 1).join(".0");
      return o.map(w.split("."), (v) => new Array(20 - v.length).join("0") + v).reverse();
    });
    for (n && (d = a - Math.min(i, s)), a -= 1; a >= d; ) {
      if (u[0][a] > u[1][a])
        return 1;
      if (u[0][a] === u[1][a]) {
        if (a === d)
          return 0;
        a -= 1;
      } else if (u[0][a] < u[1][a])
        return -1;
    }
  }
  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  static map(e, r) {
    const n = [];
    let i;
    if (Array.prototype.map)
      return Array.prototype.map.call(e, r);
    for (i = 0; i < e.length; i += 1)
      n.push(r(e[i]));
    return n;
  }
  /**
   * Array::find polyfill
   *
   * @param  {Array} arr
   * @param  {Function} predicate
   * @return {Array}
   */
  static find(e, r) {
    let n, i;
    if (Array.prototype.find)
      return Array.prototype.find.call(e, r);
    for (n = 0, i = e.length; n < i; n += 1) {
      const s = e[n];
      if (r(s, n))
        return s;
    }
  }
  /**
   * Object::assign polyfill
   *
   * @param  {Object} obj
   * @param  {Object} ...objs
   * @return {Object}
   */
  static assign(e, ...r) {
    const n = e;
    let i, s;
    if (Object.assign)
      return Object.assign(e, ...r);
    for (i = 0, s = r.length; i < s; i += 1) {
      const a = r[i];
      typeof a == "object" && a !== null && Object.keys(a).forEach((u) => {
        n[u] = a[u];
      });
    }
    return e;
  }
  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('Microsoft Edge') // edge
   *
   * @param  {string} browserName
   * @return {string}
   */
  static getBrowserAlias(e) {
    return gt[e];
  }
  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('edge') // Microsoft Edge
   *
   * @param  {string} browserAlias
   * @return {string}
   */
  static getBrowserTypeByAlias(e) {
    return Le[e] || "";
  }
}
const M = /version\/(\d+(\.?_?\d+)+)/i, ft = [
  /* Googlebot */
  {
    test: [/googlebot/i],
    describe(t) {
      const e = {
        name: "Googlebot"
      }, r = o.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, t) || o.getFirstMatch(M, t);
      return r && (e.version = r), e;
    }
  },
  /* Opera < 13.0 */
  {
    test: [/opera/i],
    describe(t) {
      const e = {
        name: "Opera"
      }, r = o.getFirstMatch(M, t) || o.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  /* Opera > 13.0 */
  {
    test: [/opr\/|opios/i],
    describe(t) {
      const e = {
        name: "Opera"
      }, r = o.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, t) || o.getFirstMatch(M, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/SamsungBrowser/i],
    describe(t) {
      const e = {
        name: "Samsung Internet for Android"
      }, r = o.getFirstMatch(M, t) || o.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/Whale/i],
    describe(t) {
      const e = {
        name: "NAVER Whale Browser"
      }, r = o.getFirstMatch(M, t) || o.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/MZBrowser/i],
    describe(t) {
      const e = {
        name: "MZ Browser"
      }, r = o.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, t) || o.getFirstMatch(M, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/focus/i],
    describe(t) {
      const e = {
        name: "Focus"
      }, r = o.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, t) || o.getFirstMatch(M, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/swing/i],
    describe(t) {
      const e = {
        name: "Swing"
      }, r = o.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, t) || o.getFirstMatch(M, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/coast/i],
    describe(t) {
      const e = {
        name: "Opera Coast"
      }, r = o.getFirstMatch(M, t) || o.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/opt\/\d+(?:.?_?\d+)+/i],
    describe(t) {
      const e = {
        name: "Opera Touch"
      }, r = o.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, t) || o.getFirstMatch(M, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/yabrowser/i],
    describe(t) {
      const e = {
        name: "Yandex Browser"
      }, r = o.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, t) || o.getFirstMatch(M, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/ucbrowser/i],
    describe(t) {
      const e = {
        name: "UC Browser"
      }, r = o.getFirstMatch(M, t) || o.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/Maxthon|mxios/i],
    describe(t) {
      const e = {
        name: "Maxthon"
      }, r = o.getFirstMatch(M, t) || o.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/epiphany/i],
    describe(t) {
      const e = {
        name: "Epiphany"
      }, r = o.getFirstMatch(M, t) || o.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/puffin/i],
    describe(t) {
      const e = {
        name: "Puffin"
      }, r = o.getFirstMatch(M, t) || o.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/sleipnir/i],
    describe(t) {
      const e = {
        name: "Sleipnir"
      }, r = o.getFirstMatch(M, t) || o.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/k-meleon/i],
    describe(t) {
      const e = {
        name: "K-Meleon"
      }, r = o.getFirstMatch(M, t) || o.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/micromessenger/i],
    describe(t) {
      const e = {
        name: "WeChat"
      }, r = o.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, t) || o.getFirstMatch(M, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/qqbrowser/i],
    describe(t) {
      const e = {
        name: /qqbrowserlite/i.test(t) ? "QQ Browser Lite" : "QQ Browser"
      }, r = o.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, t) || o.getFirstMatch(M, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/msie|trident/i],
    describe(t) {
      const e = {
        name: "Internet Explorer"
      }, r = o.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/\sedg\//i],
    describe(t) {
      const e = {
        name: "Microsoft Edge"
      }, r = o.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/edg([ea]|ios)/i],
    describe(t) {
      const e = {
        name: "Microsoft Edge"
      }, r = o.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/vivaldi/i],
    describe(t) {
      const e = {
        name: "Vivaldi"
      }, r = o.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/seamonkey/i],
    describe(t) {
      const e = {
        name: "SeaMonkey"
      }, r = o.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/sailfish/i],
    describe(t) {
      const e = {
        name: "Sailfish"
      }, r = o.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/silk/i],
    describe(t) {
      const e = {
        name: "Amazon Silk"
      }, r = o.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/phantom/i],
    describe(t) {
      const e = {
        name: "PhantomJS"
      }, r = o.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/slimerjs/i],
    describe(t) {
      const e = {
        name: "SlimerJS"
      }, r = o.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(t) {
      const e = {
        name: "BlackBerry"
      }, r = o.getFirstMatch(M, t) || o.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/(web|hpw)[o0]s/i],
    describe(t) {
      const e = {
        name: "WebOS Browser"
      }, r = o.getFirstMatch(M, t) || o.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/bada/i],
    describe(t) {
      const e = {
        name: "Bada"
      }, r = o.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/tizen/i],
    describe(t) {
      const e = {
        name: "Tizen"
      }, r = o.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, t) || o.getFirstMatch(M, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/qupzilla/i],
    describe(t) {
      const e = {
        name: "QupZilla"
      }, r = o.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, t) || o.getFirstMatch(M, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/firefox|iceweasel|fxios/i],
    describe(t) {
      const e = {
        name: "Firefox"
      }, r = o.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/electron/i],
    describe(t) {
      const e = {
        name: "Electron"
      }, r = o.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/MiuiBrowser/i],
    describe(t) {
      const e = {
        name: "Miui"
      }, r = o.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/chromium/i],
    describe(t) {
      const e = {
        name: "Chromium"
      }, r = o.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, t) || o.getFirstMatch(M, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/chrome|crios|crmo/i],
    describe(t) {
      const e = {
        name: "Chrome"
      }, r = o.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/GSA/i],
    describe(t) {
      const e = {
        name: "Google Search"
      }, r = o.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  /* Android Browser */
  {
    test(t) {
      const e = !t.test(/like android/i), r = t.test(/android/i);
      return e && r;
    },
    describe(t) {
      const e = {
        name: "Android Browser"
      }, r = o.getFirstMatch(M, t);
      return r && (e.version = r), e;
    }
  },
  /* PlayStation 4 */
  {
    test: [/playstation 4/i],
    describe(t) {
      const e = {
        name: "PlayStation 4"
      }, r = o.getFirstMatch(M, t);
      return r && (e.version = r), e;
    }
  },
  /* Safari */
  {
    test: [/safari|applewebkit/i],
    describe(t) {
      const e = {
        name: "Safari"
      }, r = o.getFirstMatch(M, t);
      return r && (e.version = r), e;
    }
  },
  /* Something else */
  {
    test: [/.*/i],
    describe(t) {
      const e = /^(.*)\/(.*) /, r = /^(.*)\/(.*)[ \t]\((.*)/, i = t.search("\\(") !== -1 ? r : e;
      return {
        name: o.getFirstMatch(i, t),
        version: o.getSecondMatch(i, t)
      };
    }
  }
], wt = [
  /* Roku */
  {
    test: [/Roku\/DVP/],
    describe(t) {
      const e = o.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, t);
      return {
        name: j.Roku,
        version: e
      };
    }
  },
  /* Windows Phone */
  {
    test: [/windows phone/i],
    describe(t) {
      const e = o.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, t);
      return {
        name: j.WindowsPhone,
        version: e
      };
    }
  },
  /* Windows */
  {
    test: [/windows /i],
    describe(t) {
      const e = o.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, t), r = o.getWindowsVersionName(e);
      return {
        name: j.Windows,
        version: e,
        versionName: r
      };
    }
  },
  /* Firefox on iPad */
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe(t) {
      const e = {
        name: j.iOS
      }, r = o.getSecondMatch(/(Version\/)(\d[\d.]+)/, t);
      return r && (e.version = r), e;
    }
  },
  /* macOS */
  {
    test: [/macintosh/i],
    describe(t) {
      const e = o.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, t).replace(/[_\s]/g, "."), r = o.getMacOSVersionName(e), n = {
        name: j.MacOS,
        version: e
      };
      return r && (n.versionName = r), n;
    }
  },
  /* iOS */
  {
    test: [/(ipod|iphone|ipad)/i],
    describe(t) {
      const e = o.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, t).replace(/[_\s]/g, ".");
      return {
        name: j.iOS,
        version: e
      };
    }
  },
  /* Android */
  {
    test(t) {
      const e = !t.test(/like android/i), r = t.test(/android/i);
      return e && r;
    },
    describe(t) {
      const e = o.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, t), r = o.getAndroidVersionName(e), n = {
        name: j.Android,
        version: e
      };
      return r && (n.versionName = r), n;
    }
  },
  /* WebOS */
  {
    test: [/(web|hpw)[o0]s/i],
    describe(t) {
      const e = o.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, t), r = {
        name: j.WebOS
      };
      return e && e.length && (r.version = e), r;
    }
  },
  /* BlackBerry */
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(t) {
      const e = o.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, t) || o.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, t) || o.getFirstMatch(/\bbb(\d+)/i, t);
      return {
        name: j.BlackBerry,
        version: e
      };
    }
  },
  /* Bada */
  {
    test: [/bada/i],
    describe(t) {
      const e = o.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, t);
      return {
        name: j.Bada,
        version: e
      };
    }
  },
  /* Tizen */
  {
    test: [/tizen/i],
    describe(t) {
      const e = o.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, t);
      return {
        name: j.Tizen,
        version: e
      };
    }
  },
  /* Linux */
  {
    test: [/linux/i],
    describe() {
      return {
        name: j.Linux
      };
    }
  },
  /* Chrome OS */
  {
    test: [/CrOS/],
    describe() {
      return {
        name: j.ChromeOS
      };
    }
  },
  /* Playstation 4 */
  {
    test: [/PlayStation 4/],
    describe(t) {
      const e = o.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, t);
      return {
        name: j.PlayStation4,
        version: e
      };
    }
  }
], ht = [
  /* Googlebot */
  {
    test: [/googlebot/i],
    describe() {
      return {
        type: "bot",
        vendor: "Google"
      };
    }
  },
  /* Huawei */
  {
    test: [/huawei/i],
    describe(t) {
      const e = o.getFirstMatch(/(can-l01)/i, t) && "Nova", r = {
        type: N.mobile,
        vendor: "Huawei"
      };
      return e && (r.model = e), r;
    }
  },
  /* Nexus Tablet */
  {
    test: [/nexus\s*(?:7|8|9|10).*/i],
    describe() {
      return {
        type: N.tablet,
        vendor: "Nexus"
      };
    }
  },
  /* iPad */
  {
    test: [/ipad/i],
    describe() {
      return {
        type: N.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  /* Firefox on iPad */
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe() {
      return {
        type: N.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  /* Amazon Kindle Fire */
  {
    test: [/kftt build/i],
    describe() {
      return {
        type: N.tablet,
        vendor: "Amazon",
        model: "Kindle Fire HD 7"
      };
    }
  },
  /* Another Amazon Tablet with Silk */
  {
    test: [/silk/i],
    describe() {
      return {
        type: N.tablet,
        vendor: "Amazon"
      };
    }
  },
  /* Tablet */
  {
    test: [/tablet(?! pc)/i],
    describe() {
      return {
        type: N.tablet
      };
    }
  },
  /* iPod/iPhone */
  {
    test(t) {
      const e = t.test(/ipod|iphone/i), r = t.test(/like (ipod|iphone)/i);
      return e && !r;
    },
    describe(t) {
      const e = o.getFirstMatch(/(ipod|iphone)/i, t);
      return {
        type: N.mobile,
        vendor: "Apple",
        model: e
      };
    }
  },
  /* Nexus Mobile */
  {
    test: [/nexus\s*[0-6].*/i, /galaxy nexus/i],
    describe() {
      return {
        type: N.mobile,
        vendor: "Nexus"
      };
    }
  },
  /* Mobile */
  {
    test: [/[^-]mobi/i],
    describe() {
      return {
        type: N.mobile
      };
    }
  },
  /* BlackBerry */
  {
    test(t) {
      return t.getBrowserName(!0) === "blackberry";
    },
    describe() {
      return {
        type: N.mobile,
        vendor: "BlackBerry"
      };
    }
  },
  /* Bada */
  {
    test(t) {
      return t.getBrowserName(!0) === "bada";
    },
    describe() {
      return {
        type: N.mobile
      };
    }
  },
  /* Windows Phone */
  {
    test(t) {
      return t.getBrowserName() === "windows phone";
    },
    describe() {
      return {
        type: N.mobile,
        vendor: "Microsoft"
      };
    }
  },
  /* Android Tablet */
  {
    test(t) {
      const e = Number(String(t.getOSVersion()).split(".")[0]);
      return t.getOSName(!0) === "android" && e >= 3;
    },
    describe() {
      return {
        type: N.tablet
      };
    }
  },
  /* Android Mobile */
  {
    test(t) {
      return t.getOSName(!0) === "android";
    },
    describe() {
      return {
        type: N.mobile
      };
    }
  },
  /* desktop */
  {
    test(t) {
      return t.getOSName(!0) === "macos";
    },
    describe() {
      return {
        type: N.desktop,
        vendor: "Apple"
      };
    }
  },
  /* Windows */
  {
    test(t) {
      return t.getOSName(!0) === "windows";
    },
    describe() {
      return {
        type: N.desktop
      };
    }
  },
  /* Linux */
  {
    test(t) {
      return t.getOSName(!0) === "linux";
    },
    describe() {
      return {
        type: N.desktop
      };
    }
  },
  /* PlayStation 4 */
  {
    test(t) {
      return t.getOSName(!0) === "playstation 4";
    },
    describe() {
      return {
        type: N.tv
      };
    }
  },
  /* Roku */
  {
    test(t) {
      return t.getOSName(!0) === "roku";
    },
    describe() {
      return {
        type: N.tv
      };
    }
  }
], bt = [
  /* EdgeHTML */
  {
    test(t) {
      return t.getBrowserName(!0) === "microsoft edge";
    },
    describe(t) {
      if (/\sedg\//i.test(t))
        return {
          name: L.Blink
        };
      const r = o.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, t);
      return {
        name: L.EdgeHTML,
        version: r
      };
    }
  },
  /* Trident */
  {
    test: [/trident/i],
    describe(t) {
      const e = {
        name: L.Trident
      }, r = o.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  /* Presto */
  {
    test(t) {
      return t.test(/presto/i);
    },
    describe(t) {
      const e = {
        name: L.Presto
      }, r = o.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  /* Gecko */
  {
    test(t) {
      const e = t.test(/gecko/i), r = t.test(/like gecko/i);
      return e && !r;
    },
    describe(t) {
      const e = {
        name: L.Gecko
      }, r = o.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  /* Blink */
  {
    test: [/(apple)?webkit\/537\.36/i],
    describe() {
      return {
        name: L.Blink
      };
    }
  },
  /* WebKit */
  {
    test: [/(apple)?webkit/i],
    describe(t) {
      const e = {
        name: L.WebKit
      }, r = o.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  }
];
class ke {
  /**
   * Create instance of Parser
   *
   * @param {String} UA User-Agent string
   * @param {Boolean} [skipParsing=false] parser can skip parsing in purpose of performance
   * improvements if you need to make a more particular parsing
   * like {@link Parser#parseBrowser} or {@link Parser#parsePlatform}
   *
   * @throw {Error} in case of empty UA String
   *
   * @constructor
   */
  constructor(e, r = !1) {
    if (e == null || e === "")
      throw new Error("UserAgent parameter can't be empty");
    this._ua = e, this.parsedResult = {}, r !== !0 && this.parse();
  }
  /**
   * Get UserAgent string of current Parser instance
   * @return {String} User-Agent String of the current <Parser> object
   *
   * @public
   */
  getUA() {
    return this._ua;
  }
  /**
   * Test a UA string for a regexp
   * @param {RegExp} regex
   * @return {Boolean}
   */
  test(e) {
    return e.test(this._ua);
  }
  /**
   * Get parsed browser object
   * @return {Object}
   */
  parseBrowser() {
    this.parsedResult.browser = {};
    const e = o.find(ft, (r) => {
      if (typeof r.test == "function")
        return r.test(this);
      if (r.test instanceof Array)
        return r.test.some((n) => this.test(n));
      throw new Error("Browser's test function is not valid");
    });
    return e && (this.parsedResult.browser = e.describe(this.getUA())), this.parsedResult.browser;
  }
  /**
   * Get parsed browser object
   * @return {Object}
   *
   * @public
   */
  getBrowser() {
    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
  }
  /**
   * Get browser's name
   * @return {String} Browser's name or an empty string
   *
   * @public
   */
  getBrowserName(e) {
    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
  }
  /**
   * Get browser's version
   * @return {String} version of browser
   *
   * @public
   */
  getBrowserVersion() {
    return this.getBrowser().version;
  }
  /**
   * Get OS
   * @return {Object}
   *
   * @example
   * this.getOS();
   * {
   *   name: 'macOS',
   *   version: '10.11.12'
   * }
   */
  getOS() {
    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
  }
  /**
   * Parse OS and save it to this.parsedResult.os
   * @return {*|{}}
   */
  parseOS() {
    this.parsedResult.os = {};
    const e = o.find(wt, (r) => {
      if (typeof r.test == "function")
        return r.test(this);
      if (r.test instanceof Array)
        return r.test.some((n) => this.test(n));
      throw new Error("Browser's test function is not valid");
    });
    return e && (this.parsedResult.os = e.describe(this.getUA())), this.parsedResult.os;
  }
  /**
   * Get OS name
   * @param {Boolean} [toLowerCase] return lower-cased value
   * @return {String} name of the OS — macOS, Windows, Linux, etc.
   */
  getOSName(e) {
    const { name: r } = this.getOS();
    return e ? String(r).toLowerCase() || "" : r || "";
  }
  /**
   * Get OS version
   * @return {String} full version with dots ('10.11.12', '5.6', etc)
   */
  getOSVersion() {
    return this.getOS().version;
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  getPlatform() {
    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
  }
  /**
   * Get platform name
   * @param {Boolean} [toLowerCase=false]
   * @return {*}
   */
  getPlatformType(e = !1) {
    const { type: r } = this.getPlatform();
    return e ? String(r).toLowerCase() || "" : r || "";
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  parsePlatform() {
    this.parsedResult.platform = {};
    const e = o.find(ht, (r) => {
      if (typeof r.test == "function")
        return r.test(this);
      if (r.test instanceof Array)
        return r.test.some((n) => this.test(n));
      throw new Error("Browser's test function is not valid");
    });
    return e && (this.parsedResult.platform = e.describe(this.getUA())), this.parsedResult.platform;
  }
  /**
   * Get parsed engine
   * @return {{}}
   */
  getEngine() {
    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
  }
  /**
   * Get engines's name
   * @return {String} Engines's name or an empty string
   *
   * @public
   */
  getEngineName(e) {
    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  parseEngine() {
    this.parsedResult.engine = {};
    const e = o.find(bt, (r) => {
      if (typeof r.test == "function")
        return r.test(this);
      if (r.test instanceof Array)
        return r.test.some((n) => this.test(n));
      throw new Error("Browser's test function is not valid");
    });
    return e && (this.parsedResult.engine = e.describe(this.getUA())), this.parsedResult.engine;
  }
  /**
   * Parse full information about the browser
   * @returns {Parser}
   */
  parse() {
    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
  }
  /**
   * Get parsed result
   * @return {ParsedResult}
   */
  getResult() {
    return o.assign({}, this.parsedResult);
  }
  /**
   * Check if parsed browser matches certain conditions
   *
   * @param {Object} checkTree It's one or two layered object,
   * which can include a platform or an OS on the first layer
   * and should have browsers specs on the bottom-laying layer
   *
   * @returns {Boolean|undefined} Whether the browser satisfies the set conditions or not.
   * Returns `undefined` when the browser is no described in the checkTree object.
   *
   * @example
   * const browser = Bowser.getParser(window.navigator.userAgent);
   * if (browser.satisfies({chrome: '>118.01.1322' }))
   * // or with os
   * if (browser.satisfies({windows: { chrome: '>118.01.1322' } }))
   * // or with platforms
   * if (browser.satisfies({desktop: { chrome: '>118.01.1322' } }))
   */
  satisfies(e) {
    const r = {};
    let n = 0;
    const i = {};
    let s = 0;
    if (Object.keys(e).forEach((d) => {
      const u = e[d];
      typeof u == "string" ? (i[d] = u, s += 1) : typeof u == "object" && (r[d] = u, n += 1);
    }), n > 0) {
      const d = Object.keys(r), u = o.find(d, (g) => this.isOS(g));
      if (u) {
        const g = this.satisfies(r[u]);
        if (g !== void 0)
          return g;
      }
      const l = o.find(
        d,
        (g) => this.isPlatform(g)
      );
      if (l) {
        const g = this.satisfies(r[l]);
        if (g !== void 0)
          return g;
      }
    }
    if (s > 0) {
      const d = Object.keys(i), u = o.find(d, (l) => this.isBrowser(l, !0));
      if (u !== void 0)
        return this.compareVersion(i[u]);
    }
  }
  /**
   * Check if the browser name equals the passed string
   * @param browserName The string to compare with the browser name
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {boolean}
   */
  isBrowser(e, r = !1) {
    const n = this.getBrowserName().toLowerCase();
    let i = e.toLowerCase();
    const s = o.getBrowserTypeByAlias(i);
    return r && s && (i = s.toLowerCase()), i === n;
  }
  compareVersion(e) {
    let r = [0], n = e, i = !1;
    const s = this.getBrowserVersion();
    if (typeof s == "string")
      return e[0] === ">" || e[0] === "<" ? (n = e.substr(1), e[1] === "=" ? (i = !0, n = e.substr(2)) : r = [], e[0] === ">" ? r.push(1) : r.push(-1)) : e[0] === "=" ? n = e.substr(1) : e[0] === "~" && (i = !0, n = e.substr(1)), r.indexOf(
        o.compareVersions(s, n, i)
      ) > -1;
  }
  isOS(e) {
    return this.getOSName(!0) === String(e).toLowerCase();
  }
  isPlatform(e) {
    return this.getPlatformType(!0) === String(e).toLowerCase();
  }
  isEngine(e) {
    return this.getEngineName(!0) === String(e).toLowerCase();
  }
  /**
   * Is anything? Check if the browser is called "anything",
   * the OS called "anything" or the platform called "anything"
   * @param {String} anything
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {Boolean}
   */
  is(e, r = !1) {
    return this.isBrowser(e, r) || this.isOS(e) || this.isPlatform(e);
  }
  /**
   * Check if any of the given values satisfies this.is(anything)
   * @param {String[]} anythings
   * @returns {Boolean}
   */
  some(e = []) {
    return e.some((r) => this.is(r));
  }
}
/*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */
class pt {
  /**
   * Creates a {@link Parser} instance
   *
   * @param {String} UA UserAgent string
   * @param {Boolean} [skipParsing=false] Will make the Parser postpone parsing until you ask it
   * explicitly. Same as `skipParsing` for {@link Parser}.
   * @returns {Parser}
   * @throws {Error} when UA is not a String
   *
   * @example
   * const parser = Bowser.getParser(window.navigator.userAgent);
   * const result = parser.getResult();
   */
  static getParser(e, r = !1) {
    if (typeof e != "string")
      throw new Error("UserAgent should be a string");
    return new ke(e, r);
  }
  /**
   * Creates a {@link Parser} instance and runs {@link Parser.getResult} immediately
   *
   * @param UA
   * @return {ParsedResult}
   *
   * @example
   * const result = Bowser.parse(window.navigator.userAgent);
   */
  static parse(e) {
    return new ke(e).getResult();
  }
  static get BROWSER_MAP() {
    return Le;
  }
  static get ENGINE_MAP() {
    return L;
  }
  static get OS_MAP() {
    return j;
  }
  static get PLATFORMS_MAP() {
    return N;
  }
}
const Ne = typeof window < "u" ? window : null;
function mt() {
  if (!Ne)
    return null;
  switch (pt.getParser(Ne.navigator.userAgent).getBrowserName()?.toLowerCase()) {
    case "firefox":
      return "firefox";
    case "microsoft edge":
      return "edge";
    case "android browser":
    case "chrome":
    case "chromium":
    case "electron":
    case "opera":
    case "vivaldi":
      return "chrome";
    default:
      return null;
  }
}
const Mt = ({
  argentMobileOptions: t,
  webWalletUrl: e,
  provider: r
}) => {
  const n = typeof window < "u" ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : !1, i = [];
  return n || (i.push(
    new fe({ options: { id: "argentX", provider: r } })
  ), i.push(
    new fe({ options: { id: "braavos", provider: r } })
  )), i.push(
    new $e({ ...t, provider: r })
  ), i.push(
    new Je({ url: e, provider: r })
  ), i;
};
var yt = typeof global == "object" && global && global.Object === Object && global;
const vt = yt;
var kt = typeof self == "object" && self && self.Object === Object && self, Nt = vt || kt || Function("return this")();
const It = Nt;
var At = It.Symbol;
const oe = At;
var Te = Object.prototype, xt = Te.hasOwnProperty, jt = Te.toString, Z = oe ? oe.toStringTag : void 0;
function Dt(t) {
  var e = xt.call(t, Z), r = t[Z];
  try {
    t[Z] = void 0;
    var n = !0;
  } catch {
  }
  var i = jt.call(t);
  return n && (e ? t[Z] = r : delete t[Z]), i;
}
var zt = Object.prototype, Ct = zt.toString;
function St(t) {
  return Ct.call(t);
}
var Ot = "[object Null]", _t = "[object Undefined]", Ie = oe ? oe.toStringTag : void 0;
function Lt(t) {
  return t == null ? t === void 0 ? _t : Ot : Ie && Ie in Object(t) ? Dt(t) : St(t);
}
function Tt(t) {
  return t != null && typeof t == "object";
}
var Et = Array.isArray;
const Ft = Et;
var Bt = "[object String]";
function Ae(t) {
  return typeof t == "string" || !Ft(t) && Tt(t) && Lt(t) == Bt;
}
const Wt = ({
  availableConnectors: t,
  installedWallets: e,
  discoveryWallets: r,
  storeVersion: n
}) => window?.starknet_argentX?.isInAppBrowser ? [] : t.map((a) => {
  const d = e.find((l) => l.id === a.id);
  if (d) {
    const l = d.id === "argentX" ? Me : d.icon;
    return {
      name: d.name,
      id: d.id,
      icon: { light: l, dark: l },
      connector: a
    };
  }
  const u = r.filter(
    (l) => !!l.downloads[n]
  ).find((l) => l.id === a.id);
  if (u) {
    const { downloads: l } = u, g = u.id === "argentX" ? Me : u.icon;
    return {
      name: u.name,
      id: u.id,
      icon: { light: g, dark: g },
      connector: a,
      download: l[n]
    };
  }
  return !a || !a.id || !a.name ? null : {
    name: a.name,
    id: a.id,
    icon: a.icon,
    connector: a,
    title: "title" in a && Ae(a.title) ? a.title : void 0,
    subtitle: "subtitle" in a && Ae(a.subtitle) ? a.subtitle : void 0
  };
}).filter((a) => a !== null);
function Q() {
}
function Ee(t) {
  return t();
}
function xe() {
  return /* @__PURE__ */ Object.create(null);
}
function F(t) {
  t.forEach(Ee);
}
function Fe(t) {
  return typeof t == "function";
}
function Be(t, e) {
  return t != t ? e == e : t !== e || t && typeof t == "object" || typeof t == "function";
}
let ee;
function We(t, e) {
  return ee || (ee = document.createElement("a")), ee.href = e, t === ee.href;
}
function Pt(t) {
  return Object.keys(t).length === 0;
}
function y(t, e) {
  t.appendChild(e);
}
function B(t, e, r) {
  t.insertBefore(e, r || null);
}
function _(t) {
  t.parentNode && t.parentNode.removeChild(t);
}
function Qt(t, e) {
  for (let r = 0; r < t.length; r += 1)
    t[r] && t[r].d(e);
}
function A(t) {
  return document.createElement(t);
}
function U(t) {
  return document.createTextNode(t);
}
function T() {
  return U(" ");
}
function Pe() {
  return U("");
}
function C(t, e, r, n) {
  return t.addEventListener(e, r, n), () => t.removeEventListener(e, r, n);
}
function f(t, e, r) {
  r == null ? t.removeAttribute(e) : t.getAttribute(e) !== r && t.setAttribute(e, r);
}
function Ut(t) {
  return Array.from(t.childNodes);
}
function se(t, e) {
  e = "" + e, t.data !== e && (t.data = /** @type {string} */
  e);
}
function Qe(t, e, r, n) {
  r == null ? t.style.removeProperty(e) : t.style.setProperty(e, r, n ? "important" : "");
}
let J;
function q(t) {
  J = t;
}
function Yt() {
  if (!J)
    throw new Error("Function called outside component initialization");
  return J;
}
function Rt(t) {
  Yt().$$.on_mount.push(t);
}
const R = [], je = [];
let G = [];
const De = [], Gt = /* @__PURE__ */ Promise.resolve();
let he = !1;
function Vt() {
  he || (he = !0, Gt.then(Ue));
}
function be(t) {
  G.push(t);
}
const ge = /* @__PURE__ */ new Set();
let Y = 0;
function Ue() {
  if (Y !== 0)
    return;
  const t = J;
  do {
    try {
      for (; Y < R.length; ) {
        const e = R[Y];
        Y++, q(e), Zt(e.$$);
      }
    } catch (e) {
      throw R.length = 0, Y = 0, e;
    }
    for (q(null), R.length = 0, Y = 0; je.length; )
      je.pop()();
    for (let e = 0; e < G.length; e += 1) {
      const r = G[e];
      ge.has(r) || (ge.add(r), r());
    }
    G.length = 0;
  } while (R.length);
  for (; De.length; )
    De.pop()();
  he = !1, ge.clear(), q(t);
}
function Zt(t) {
  if (t.fragment !== null) {
    t.update(), F(t.before_update);
    const e = t.dirty;
    t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, e), t.after_update.forEach(be);
  }
}
function Xt(t) {
  const e = [], r = [];
  G.forEach((n) => t.indexOf(n) === -1 ? e.push(n) : r.push(n)), r.forEach((n) => n()), G = e;
}
const ne = /* @__PURE__ */ new Set();
let P;
function Ye() {
  P = {
    r: 0,
    c: [],
    p: P
    // parent group
  };
}
function Re() {
  P.r || F(P.c), P = P.p;
}
function E(t, e) {
  t && t.i && (ne.delete(t), t.i(e));
}
function K(t, e, r, n) {
  if (t && t.o) {
    if (ne.has(t))
      return;
    ne.add(t), P.c.push(() => {
      ne.delete(t), n && (r && t.d(1), n());
    }), t.o(e);
  } else
    n && n();
}
function ze(t) {
  return t?.length !== void 0 ? t : Array.from(t);
}
function Ht(t) {
  t && t.c();
}
function Ge(t, e, r) {
  const { fragment: n, after_update: i } = t.$$;
  n && n.m(e, r), be(() => {
    const s = t.$$.on_mount.map(Ee).filter(Fe);
    t.$$.on_destroy ? t.$$.on_destroy.push(...s) : F(s), t.$$.on_mount = [];
  }), i.forEach(be);
}
function Ve(t, e) {
  const r = t.$$;
  r.fragment !== null && (Xt(r.after_update), F(r.on_destroy), r.fragment && r.fragment.d(e), r.on_destroy = r.fragment = null, r.ctx = []);
}
function qt(t, e) {
  t.$$.dirty[0] === -1 && (R.push(t), Vt(), t.$$.dirty.fill(0)), t.$$.dirty[e / 31 | 0] |= 1 << e % 31;
}
function Ze(t, e, r, n, i, s, a, d = [-1]) {
  const u = J;
  q(t);
  const l = t.$$ = {
    fragment: null,
    ctx: [],
    // state
    props: s,
    update: Q,
    not_equal: i,
    bound: xe(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(e.context || (u ? u.$$.context : [])),
    // everything else
    callbacks: xe(),
    dirty: d,
    skip_bound: !1,
    root: e.target || u.$$.root
  };
  a && a(l.root);
  let g = !1;
  if (l.ctx = r ? r(t, e.props || {}, (w, v, ...b) => {
    const x = b.length ? b[0] : v;
    return l.ctx && i(l.ctx[w], l.ctx[w] = x) && (!l.skip_bound && l.bound[w] && l.bound[w](x), g && qt(t, w)), v;
  }) : [], l.update(), g = !0, F(l.before_update), l.fragment = n ? n(l.ctx) : !1, e.target) {
    if (e.hydrate) {
      const w = Ut(e.target);
      l.fragment && l.fragment.l(w), w.forEach(_);
    } else
      l.fragment && l.fragment.c();
    e.intro && E(t.$$.fragment), Ge(t, e.target, e.anchor), Ue();
  }
  q(u);
}
class Xe {
  constructor() {
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    ae(this, "$$");
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    ae(this, "$$set");
  }
  /** @returns {void} */
  $destroy() {
    Ve(this, 1), this.$destroy = Q;
  }
  /**
   * @template {Extract<keyof Events, string>} K
   * @param {K} type
   * @param {((e: Events[K]) => void) | null | undefined} callback
   * @returns {() => void}
   */
  $on(e, r) {
    if (!Fe(r))
      return Q;
    const n = this.$$.callbacks[e] || (this.$$.callbacks[e] = []);
    return n.push(r), () => {
      const i = n.indexOf(r);
      i !== -1 && n.splice(i, 1);
    };
  }
  /**
   * @param {Partial<Props>} props
   * @returns {void}
   */
  $set(e) {
    this.$$set && !Pt(e) && (this.$$.skip_bound = !0, this.$$set(e), this.$$.skip_bound = !1);
  }
}
const Jt = "4";
typeof window < "u" && (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add(Jt);
function Kt(t) {
  let e, r, n, i, s, a = (
    /*wallet*/
    (t[0].title ?? /*wallet*/
    t[0].name) + ""
  ), d, u, l, g = (
    /*wallet*/
    (t[0].subtitle ?? "") + ""
  ), w, v, b, x;
  function k(h, p) {
    return (
      /*loadingItem*/
      h[2] === /*wallet*/
      h[0]?.id ? rr : (
        /*isSvg*/
        h[4] ? tr : er
      )
    );
  }
  let m = k(t), c = m(t);
  return {
    c() {
      e = A("li"), r = A("span"), n = T(), i = A("div"), s = A("p"), d = U(a), u = T(), l = A("p"), w = U(g), v = T(), c.c(), f(r, "class", "w-8 h-8"), f(s, "class", "font-semibold text-base p"), f(l, "class", "l2 p"), Qe(l, "text-align", "center"), f(i, "class", "flex flex-col justify-center items-center"), f(e, "class", `flex flex-row-reverse justify-between items-center 
            p-3 rounded-md cursor-pointer shadow-list-item 
            dark:shadow-none dark:bg-neutral-800 dark:text-white 
          hover:bg-neutral-100 dark:hover:bg-neutral-700 
          focus:outline-none focus:ring-2 
        focus:ring-neutral-200 dark:focus:ring-neutral-700 
          transition-colors`), f(e, "role", "button"), f(e, "tabindex", "0");
    },
    m(h, p) {
      B(h, e, p), y(e, r), y(e, n), y(e, i), y(i, s), y(s, d), y(i, u), y(i, l), y(l, w), y(e, v), c.m(e, null), b || (x = [
        C(
          e,
          "click",
          /*click_handler_1*/
          t[8]
        ),
        C(
          e,
          "keyup",
          /*keyup_handler_1*/
          t[9]
        )
      ], b = !0);
    },
    p(h, p) {
      p & /*wallet*/
      1 && a !== (a = /*wallet*/
      (h[0].title ?? /*wallet*/
      h[0].name) + "") && se(d, a), p & /*wallet*/
      1 && g !== (g = /*wallet*/
      (h[0].subtitle ?? "") + "") && se(w, g), m === (m = k(h)) && c ? c.p(h, p) : (c.d(1), c = m(h), c && (c.c(), c.m(e, null)));
    },
    d(h) {
      h && _(e), c.d(), b = !1, F(x);
    }
  };
}
function $t(t) {
  let e, r, n, i, s, a, d = (
    /*wallet*/
    t[0].name + ""
  ), u, l, g, w, v, b, x, k, m;
  return {
    c() {
      e = A("a"), r = A("li"), n = A("span"), i = T(), s = A("p"), a = U("Install "), u = U(d), l = T(), g = A("img"), f(n, "class", "w-8 h-8"), f(s, "class", "font-semibold text-base p"), f(g, "alt", w = /*wallet*/
      t[0].name), We(g.src, v = /*icon*/
      t[3]) || f(g, "src", v), f(g, "class", "w-8 h-8 rounded-full"), f(r, "class", `flex flex-row-reverse justify-between items-center 
              p-3 rounded-md cursor-pointer shadow-list-item 
              dark:shadow-none dark:bg-neutral-800 dark:text-white 
            hover:bg-neutral-100 dark:hover:bg-neutral-700`), f(e, "aria-label", b = /*wallet*/
      t[0].name + " download link"), f(e, "href", x = /*wallet*/
      t[0].download), f(e, "target", "_blank"), f(e, "rel", "noopener noreferrer"), f(e, "class", `rounded-md focus:outline-none  focus:ring-2 
    focus:ring-neutral-200  dark:focus:ring-neutral-700 transition-colors`);
    },
    m(c, h) {
      B(c, e, h), y(e, r), y(r, n), y(r, i), y(r, s), y(s, a), y(s, u), y(r, l), y(r, g), k || (m = [
        C(
          r,
          "click",
          /*click_handler*/
          t[6]
        ),
        C(
          r,
          "keyup",
          /*keyup_handler*/
          t[7]
        )
      ], k = !0);
    },
    p(c, h) {
      h & /*wallet*/
      1 && d !== (d = /*wallet*/
      c[0].name + "") && se(u, d), h & /*wallet*/
      1 && w !== (w = /*wallet*/
      c[0].name) && f(g, "alt", w), h & /*wallet*/
      1 && b !== (b = /*wallet*/
      c[0].name + " download link") && f(e, "aria-label", b), h & /*wallet*/
      1 && x !== (x = /*wallet*/
      c[0].download) && f(e, "href", x);
    },
    d(c) {
      c && _(e), k = !1, F(m);
    }
  };
}
function er(t) {
  let e, r, n;
  return {
    c() {
      e = A("img"), f(e, "alt", r = /*wallet*/
      t[0]?.name), We(e.src, n = /*icon*/
      t[3]) || f(e, "src", n), f(e, "class", "w-8 h-8 rounded");
    },
    m(i, s) {
      B(i, e, s);
    },
    p(i, s) {
      s & /*wallet*/
      1 && r !== (r = /*wallet*/
      i[0]?.name) && f(e, "alt", r);
    },
    d(i) {
      i && _(e);
    }
  };
}
function tr(t) {
  let e;
  return {
    c() {
      e = A("div"), Qe(e, "position", "relative");
    },
    m(r, n) {
      B(r, e, n), e.innerHTML = /*icon*/
      t[3];
    },
    p: Q,
    d(r) {
      r && _(e);
    }
  };
}
function rr(t) {
  let e;
  return {
    c() {
      e = A("div"), e.innerHTML = '<svg aria-hidden="true" class="w-8 h-8 text-neutral-300 animate-spin dark:text-neutral-600 fill-neutral-600 dark:fill-neutral-300" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"></path><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"></path></svg> <span class="sr-only">Loading...</span>', f(e, "role", "status");
    },
    m(r, n) {
      B(r, e, n);
    },
    p: Q,
    d(r) {
      r && _(e);
    }
  };
}
function nr(t) {
  let e;
  function r(s, a) {
    return (
      /*wallet*/
      s[0].download ? $t : Kt
    );
  }
  let n = r(t), i = n(t);
  return {
    c() {
      i.c(), e = Pe();
    },
    m(s, a) {
      i.m(s, a), B(s, e, a);
    },
    p(s, [a]) {
      n === (n = r(s)) && i ? i.p(s, a) : (i.d(1), i = n(s), i && (i.c(), i.m(e.parentNode, e)));
    },
    i: Q,
    o: Q,
    d(s) {
      s && _(e), i.d(s);
    }
  };
}
function ir(t, e, r) {
  let { wallet: n } = e, { theme: i = null } = e, { cb: s = async () => {
  } } = e, { loadingItem: a = !1 } = e;
  const d = i === "dark" ? n.icon.dark : n.icon.light, u = d?.startsWith("<svg"), l = () => {
    s(null);
  }, g = (b) => {
    b.key === "Enter" && s(null);
  }, w = async () => {
    s(n.connector);
  }, v = async (b) => {
    b.key === "Enter" && s(n.connector);
  };
  return t.$$set = (b) => {
    "wallet" in b && r(0, n = b.wallet), "theme" in b && r(5, i = b.theme), "cb" in b && r(1, s = b.cb), "loadingItem" in b && r(2, a = b.loadingItem);
  }, [
    n,
    s,
    a,
    d,
    u,
    i,
    l,
    g,
    w,
    v
  ];
}
class or extends Xe {
  constructor(e) {
    super(), Ze(this, e, ir, nr, Be, {
      wallet: 0,
      theme: 5,
      cb: 1,
      loadingItem: 2
    });
  }
}
function Ce(t, e, r) {
  const n = t.slice();
  return n[14] = e[r], n;
}
function Se(t) {
  let e, r, n, i, s, a, d, u, l, g, w, v, b, x, k, m = ze(
    /*modalWallets*/
    t[1]
  ), c = [];
  for (let p = 0; p < m.length; p += 1)
    c[p] = Oe(Ce(t, m, p));
  const h = (p) => K(c[p], 1, 1, () => {
    c[p] = null;
  });
  return {
    c() {
      e = A("div"), r = A("main"), n = A("header"), i = A("h2"), i.textContent = "Connect to", s = T(), a = A("h1"), d = U(
        /*dappName*/
        t[0]
      ), u = T(), l = A("span"), l.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.77275 3.02275C9.99242 2.80308 9.99242 2.44692 9.77275 2.22725C9.55308 2.00758 9.19692 2.00758 8.97725 2.22725L6 5.20451L3.02275 2.22725C2.80308 2.00758 2.44692 2.00758 2.22725 2.22725C2.00758 2.44692 2.00758 2.80308 2.22725 3.02275L5.20451 6L2.22725 8.97725C2.00758 9.19692 2.00758 9.55308 2.22725 9.77275C2.44692 9.99242 2.80308 9.99242 3.02275 9.77275L6 6.79549L8.97725 9.77275C9.19692 9.99242 9.55308 9.99242 9.77275 9.77275C9.99242 9.55308 9.99242 9.19692 9.77275 8.97725L6.79549 6L9.77275 3.02275Z" fill="currentColor"></path></svg>', g = T(), w = A("ul");
      for (let p = 0; p < c.length; p += 1)
        c[p].c();
      f(i, "class", "text-sm text-gray-400 font-semibold"), f(a, "class", `text-xl font-semibold mb-6 
                  max-w-[240px] overflow-hidden 
                  whitespace-nowrap text-ellipsis`), f(l, "class", `absolute top-0 right-0 p-2 cursor-pointer
                  rounded-full bg-neutral-100 dark:bg-neutral-800
                  text-neutral-400 dark:text-white
                  hover:bg-neutral-100 dark:hover:bg-neutral-700
                  focus:outline-none focus:ring-2
                focus:ring-neutral-200 dark:focus:ring-neutral-700
                  transition-colors`), f(l, "role", "button"), f(l, "tabindex", "0"), f(l, "aria-label", "Close"), f(n, "class", "flex items-center justify-center flex-col mb-2 relative"), f(w, "class", "flex flex-col gap-3"), f(r, "role", "dialog"), f(r, "class", `rounded-3xl shadow-modal dark:shadow-none 
              w-full max-w-[380px] z-50 
              mx-6 p-6 pb-8 text-center 
              bg-slate-50 dark:bg-neutral-900 
            text-neutral-900 dark:text-white`), f(e, "part", "starknetkit-modal"), f(e, "class", v = `modal-font backdrop-blur-sm fixed inset-0 flex items-center 
            justify-center bg-black/25 z-[9999] ${/*darkModeControlClass*/
      t[4]}`);
    },
    m(p, D) {
      B(p, e, D), y(e, r), y(r, n), y(n, i), y(n, s), y(n, a), y(a, d), y(n, u), y(n, l), y(r, g), y(r, w);
      for (let I = 0; I < c.length; I += 1)
        c[I] && c[I].m(w, null);
      b = !0, x || (k = [
        C(
          l,
          "click",
          /*click_handler*/
          t[8]
        ),
        C(
          l,
          "keyup",
          /*keyup_handler*/
          t[9]
        ),
        C(r, "click", ar),
        C(r, "keyup", cr),
        C(
          e,
          "click",
          /*click_handler_2*/
          t[10]
        ),
        C(
          e,
          "keyup",
          /*keyup_handler_2*/
          t[11]
        )
      ], x = !0);
    },
    p(p, D) {
      if ((!b || D & /*dappName*/
      1) && se(
        d,
        /*dappName*/
        p[0]
      ), D & /*modalWallets, loadingItem, cb, theme*/
      78) {
        m = ze(
          /*modalWallets*/
          p[1]
        );
        let I;
        for (I = 0; I < m.length; I += 1) {
          const me = Ce(p, m, I);
          c[I] ? (c[I].p(me, D), E(c[I], 1)) : (c[I] = Oe(me), c[I].c(), E(c[I], 1), c[I].m(w, null));
        }
        for (Ye(), I = m.length; I < c.length; I += 1)
          h(I);
        Re();
      }
      (!b || D & /*darkModeControlClass*/
      16 && v !== (v = `modal-font backdrop-blur-sm fixed inset-0 flex items-center 
            justify-center bg-black/25 z-[9999] ${/*darkModeControlClass*/
      p[4]}`)) && f(e, "class", v);
    },
    i(p) {
      if (!b) {
        for (let D = 0; D < m.length; D += 1)
          E(c[D]);
        b = !0;
      }
    },
    o(p) {
      c = c.filter(Boolean);
      for (let D = 0; D < c.length; D += 1)
        K(c[D]);
      b = !1;
    },
    d(p) {
      p && _(e), Qt(c, p), x = !1, F(k);
    }
  };
}
function Oe(t) {
  let e, r;
  return e = new or({
    props: {
      wallet: (
        /*wallet*/
        t[14]
      ),
      loadingItem: (
        /*loadingItem*/
        t[3]
      ),
      cb: (
        /*cb*/
        t[6]
      ),
      theme: (
        /*theme*/
        t[2]
      )
    }
  }), {
    c() {
      Ht(e.$$.fragment);
    },
    m(n, i) {
      Ge(e, n, i), r = !0;
    },
    p(n, i) {
      const s = {};
      i & /*modalWallets*/
      2 && (s.wallet = /*wallet*/
      n[14]), i & /*loadingItem*/
      8 && (s.loadingItem = /*loadingItem*/
      n[3]), i & /*theme*/
      4 && (s.theme = /*theme*/
      n[2]), e.$set(s);
    },
    i(n) {
      r || (E(e.$$.fragment, n), r = !0);
    },
    o(n) {
      K(e.$$.fragment, n), r = !1;
    },
    d(n) {
      Ve(e, n);
    }
  };
}
function sr(t) {
  let e, r, n = !/*isInAppBrowser*/
  t[5] && /*modalWallets*/
  t[1].length > 1 && Se(t);
  return {
    c() {
      n && n.c(), e = Pe();
    },
    m(i, s) {
      n && n.m(i, s), B(i, e, s), r = !0;
    },
    p(i, [s]) {
      !/*isInAppBrowser*/
      i[5] && /*modalWallets*/
      i[1].length > 1 ? n ? (n.p(i, s), s & /*modalWallets*/
      2 && E(n, 1)) : (n = Se(i), n.c(), E(n, 1), n.m(e.parentNode, e)) : n && (Ye(), K(n, 1, 1, () => {
        n = null;
      }), Re());
    },
    i(i) {
      r || (E(n), r = !0);
    },
    o(i) {
      K(n), r = !1;
    },
    d(i) {
      i && _(e), n && n.d(i);
    }
  };
}
const ar = (t) => t.stopPropagation(), cr = (t) => {
  t.stopPropagation();
};
function lr(t, e, r) {
  let { dappName: n = window?.document.title ?? "" } = e, { modalWallets: i } = e, { callback: s = async () => {
  } } = e, { theme: a = null } = e, d = !1, l = window?.starknet_argentX?.isInAppBrowser;
  const g = (c) => {
    r(3, d = c);
  };
  let w = async (c) => {
    g(c?.id ?? !1);
    try {
      await s(c ?? null);
    } finally {
      g(!1);
    }
  }, v = a === "dark" ? "dark" : "";
  Rt(async () => {
    if (a === "dark" || a === null && window.matchMedia("(prefers-color-scheme: dark)").matches ? r(4, v = "dark") : r(4, v = ""), l && window?.starknet_argentX) {
      try {
        s(new fe({ options: { id: "argentX" } }));
      } catch {
      }
      return;
    }
    if (i.length === 1)
      try {
        const [c] = i;
        await s(c.connector);
      } catch (c) {
        console.error(c);
      }
  });
  const b = () => w(null), x = (c) => {
    c.key === "Enter" && w(null);
  }, k = () => w(null), m = (c) => {
    c.key === "Escape" && w(null);
  };
  return t.$$set = (c) => {
    "dappName" in c && r(0, n = c.dappName), "modalWallets" in c && r(1, i = c.modalWallets), "callback" in c && r(7, s = c.callback), "theme" in c && r(2, a = c.theme);
  }, [
    n,
    i,
    a,
    d,
    v,
    l,
    w,
    s,
    b,
    x,
    k,
    m
  ];
}
class dr extends Xe {
  constructor(e) {
    super(), Ze(this, e, lr, sr, Be, {
      dappName: 0,
      modalWallets: 1,
      callback: 7,
      theme: 2
    });
  }
}
const ur = `@import"https://fonts.googleapis.com/css2?family=Barlow:wght@500;600&display=swap";.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.inset-0{inset:0}.top-0{top:0}.right-0{right:0}.z-\\[9999\\]{z-index:9999}.z-50{z-index:50}.mx-6{margin-left:1.5rem;margin-right:1.5rem}.mb-2{margin-bottom:.5rem}.mb-6{margin-bottom:1.5rem}.inline{display:inline}.flex{display:flex}.h-8{height:2rem}.w-8{width:2rem}.w-full{width:100%}.max-w-\\[380px\\]{max-width:380px}.max-w-\\[240px\\]{max-width:240px}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@keyframes spin{to{transform:rotate(360deg)}}.animate-spin{animation:spin 1s linear infinite}.cursor-pointer{cursor:pointer}.flex-row-reverse{flex-direction:row-reverse}.flex-col{flex-direction:column}.items-center{align-items:center}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-3{gap:.75rem}.overflow-hidden{overflow:hidden}.text-ellipsis{text-overflow:ellipsis}.whitespace-nowrap{white-space:nowrap}.rounded-md{border-radius:.375rem}.rounded-full{border-radius:9999px}.rounded{border-radius:.25rem}.rounded-3xl{border-radius:1.5rem}.border{border-width:1px}.bg-black\\/25{background-color:#00000040}.bg-slate-50{--tw-bg-opacity: 1;background-color:rgb(248 250 252 / var(--tw-bg-opacity))}.bg-neutral-100{--tw-bg-opacity: 1;background-color:rgb(245 245 245 / var(--tw-bg-opacity))}.fill-neutral-600{fill:#525252}.p-3{padding:.75rem}.p-6{padding:1.5rem}.p-2{padding:.5rem}.pb-8{padding-bottom:2rem}.text-center{text-align:center}.text-base{font-size:1rem;line-height:1.5rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-xl{font-size:1.25rem;line-height:1.75rem}.font-semibold{font-weight:600}.text-neutral-300{--tw-text-opacity: 1;color:rgb(212 212 212 / var(--tw-text-opacity))}.text-neutral-900{--tw-text-opacity: 1;color:rgb(23 23 23 / var(--tw-text-opacity))}.text-gray-400{--tw-text-opacity: 1;color:rgb(156 163 175 / var(--tw-text-opacity))}.text-neutral-400{--tw-text-opacity: 1;color:rgb(163 163 163 / var(--tw-text-opacity))}.shadow-list-item{--tw-shadow: 0px 2px 12px rgba(0, 0, 0, .12);--tw-shadow-colored: 0px 2px 12px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-modal{--tw-shadow: 0px 4px 20px rgba(0, 0, 0, .5);--tw-shadow-colored: 0px 4px 20px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.outline{outline-style:solid}.blur{--tw-blur: blur(8px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.backdrop-blur-sm{--tw-backdrop-blur: blur(4px);-webkit-backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)}.transition-colors{transition-property:color,background-color,border-color,fill,stroke,-webkit-text-decoration-color;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,-webkit-text-decoration-color;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji"}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.modal-font{font-family:Barlow,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-webkit-text-size-adjust:100%;-moz-text-size-adjust:100%;text-size-adjust:100%;font-feature-settings:"kern"}.l2{color:#8c8c8c;font-size:12px;font-weight:500;line-height:14px;letter-spacing:0em;text-align:left}.p{margin:0}.hover\\:bg-neutral-100:hover{--tw-bg-opacity: 1;background-color:rgb(245 245 245 / var(--tw-bg-opacity))}.focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.focus\\:ring-2:focus{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.focus\\:ring-neutral-200:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(229 229 229 / var(--tw-ring-opacity))}.dark .dark\\:bg-neutral-800{--tw-bg-opacity: 1;background-color:rgb(38 38 38 / var(--tw-bg-opacity))}.dark .dark\\:bg-neutral-900{--tw-bg-opacity: 1;background-color:rgb(23 23 23 / var(--tw-bg-opacity))}.dark .dark\\:fill-neutral-300{fill:#d4d4d4}.dark .dark\\:text-white{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity))}.dark .dark\\:text-neutral-600{--tw-text-opacity: 1;color:rgb(82 82 82 / var(--tw-text-opacity))}.dark .dark\\:shadow-none{--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.dark .dark\\:hover\\:bg-neutral-700:hover{--tw-bg-opacity: 1;background-color:rgb(64 64 64 / var(--tw-bg-opacity))}.dark .dark\\:focus\\:ring-neutral-700:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(64 64 64 / var(--tw-ring-opacity))}
`, yr = (t) => ({
  starknetkitConnectModal: async () => await gr({
    ...t,
    resultType: t.resultType ?? "connector"
  })
});
let O = null;
const gr = async ({
  modalMode: t = "canAsk",
  storeVersion: e = mt(),
  modalTheme: r,
  dappName: n,
  webWalletUrl: i = Ke,
  argentMobileOptions: s,
  connectors: a = [],
  resultType: d = "wallet",
  provider: u,
  ...l
} = {}) => {
  O = null;
  const g = !a || a.length === 0 ? Mt({
    argentMobileOptions: s,
    webWalletUrl: i,
    provider: u
  }) : a, w = localStorage.getItem("starknetLastConnectedWallet");
  if (t === "neverAsk") {
    const k = g.find((m) => m.id === w);
    return d === "wallet" && await k?.connect(), O = k ?? null, {
      connector: k,
      wallet: k?.wallet ?? null
    };
  }
  const v = await re.getAvailableWallets(l);
  if (t === "canAsk" && w && ((await re.getPreAuthorizedWallets({
    ...l
  })).find((c) => c.id === w) ?? v.length === 1 ? v[0] : void 0)) {
    const c = g.find((h) => h.id === w);
    return d === "wallet" && await c?.connect(), c && (O = c), {
      connector: c,
      wallet: c?.wallet ?? null
    };
  }
  const b = Wt({
    availableConnectors: g,
    installedWallets: v,
    discoveryWallets: await re.getDiscoveryWallets(l),
    storeVersion: e
  }), x = () => {
    const k = "starknetkit-modal-container", m = document.getElementById(k);
    if (m) {
      if (m.shadowRoot)
        return m.shadowRoot;
      m.remove();
    }
    const c = document.createElement("div");
    c.id = k, document.body.appendChild(c);
    const h = c.attachShadow({ mode: "open" });
    return h.innerHTML = `<style>${ur}</style>`, h;
  };
  return new Promise((k, m) => {
    const c = new dr({
      target: x(),
      props: {
        dappName: n,
        callback: async (h) => {
          try {
            O = h, d === "wallet" ? (await h?.connect(), h !== null && h.id !== "argentWebWallet" && et(h.id), k({
              connector: h,
              wallet: h?.wallet ?? null
            })) : k({
              connector: h
            });
          } catch (p) {
            m(p);
          } finally {
            setTimeout(() => c.$destroy());
          }
        },
        theme: r === "system" ? null : r ?? null,
        modalWallets: b
      }
    });
  });
}, vr = () => O ? O.wallet : null, kr = async (t = {}) => (tt(), O && await O.disconnect(), O = null, re.disconnect(t));
export {
  gr as connect,
  kr as disconnect,
  vr as getSelectedConnectorWallet,
  yr as useStarknetkitConnectModal
};
